import {
    DISMISS_NOTIFICATION
} from '..'

export default class ResponseNotification {

    static dismiss(value) {
        return (dispatch) => dispatch({
            type: DISMISS_NOTIFICATION,
            notificationType: DISMISS_NOTIFICATION,
            index: value
        })
    }

}



// WEBPACK FOOTER //
// src/actions/response-notification/index.js